// src/beta/services/catalog.ts
import { betaFetch } from '@/beta/services/api';
import type {
  CatalogPayload,
  CatalogPayloadWire,
  CatalogVehicle,
  CatalogVehicleWire,
  Tier,
} from '@/beta/types/catalog';

const EDITION = 'sleeping-beauties';
const EDITION_LABEL = 'Edition I · April 2026';

const QUERY = new URLSearchParams({
  include: 'hero,tier,span',
  edition: EDITION,
}).toString();

function toDomain(v: CatalogVehicleWire): CatalogVehicle {
  const tier: Tier = v.tier ?? 'partial';
  return {
    id: v.id,
    name: v.name,
    year: v.year ?? null,
    make: v.make ?? null,
    model: v.model ?? null,
    heroImageUrl: v.hero_image_url ?? null,
    tier,
    coveragePercent: v.coverage_percent ?? null,
    ownershipSpan: {
      from: v.ownership_span?.from ?? null,
      to: v.ownership_span?.to ?? null,
      location: v.ownership_span?.location ?? null,
    },
  };
}

export interface GetCatalogOptions {
  signal?: AbortSignal;
}

/**
 * Fetch the Sleeping Beauties catalog. Returns the domain-shape payload
 * with totals computed client-side. Throws BetaApiError on non-2xx.
 */
export async function getCatalog(opts: GetCatalogOptions = {}): Promise<CatalogPayload> {
  const wire = await betaFetch<CatalogPayloadWire>(`/vehicles?${QUERY}`, {
    signal: opts.signal,
  });

  const vehicles = wire.vehicles.map(toDomain);
  const vaulted = vehicles.filter((v) => v.tier === 'vaulted').length;

  return {
    vehicles,
    edition: EDITION,
    editionLabel: EDITION_LABEL,
    totals: {
      vehicles: vehicles.length,
      photos: 0,       // Phase H: wire to /v1/exhibitions/[slug]/totals
      documents: 0,    // Phase H: ditto
      vaulted,
    },
  };
}
